import SvgIcon from "./IconStatus.svg?react";
const IconStatus = SvgIcon;
export default IconStatus;
